<!-- Dashboard Hub Header -->
<div style="margin-bottom: 16px;">
  <nz-card>
    <div nz-row nzJustify="space-between" nzAlign="middle">
      <div nz-col>
        <h2 style="margin: 0;">Dashboards</h2>
        <p style="margin: 4px 0 0; color: #666; font-size: 13px;">
          Select a dashboard to view detailed metrics and KPIs
        </p>
      </div>
    </div>
  </nz-card>
</div>

<!-- Dashboard Cards Grid -->
<div nz-row [nzGutter]="[16, 16]">
  @for (card of dashboardCards; track card) {
    <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
      <nz-card nzHoverable [nzBodyStyle]="{padding: '24px', cursor: 'pointer'}" (click)="navigateToDashboard(card)"
        class="dashboard-hub-card">
        <!-- Card Header -->
        <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
        <div [ngStyle]="{
          background: card.color + '15',
          borderRadius: '8px',
          padding: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }">
            <i nz-icon [nzType]="card.icon" nzTheme="outline"
            [ngStyle]="{fontSize: '24px', color: card.color}"></i>
          </div>
          <div>
            <h3 style="margin: 0; font-size: 16px; font-weight: 600;">{{ card.title }}</h3>
          </div>
        </div>
        <!-- Card Description -->
        <p style="color: #666; font-size: 13px; margin-bottom: 16px; min-height: 40px;">
          {{ card.description }}
        </p>
        <!-- Headline Metrics -->
        @if (card.isLoading) {
          <div style="padding: 8px 0;">
            <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 1 }"></nz-skeleton>
          </div>
        }
        @if (!card.isLoading && card.headlineTiles.length > 0) {
          <div>
            <nz-divider style="margin: 8px 0;"></nz-divider>
            <div nz-row [nzGutter]="8">
              @for (headline of card.headlineTiles; track headline) {
                <div nz-col [nzSpan]="8" style="text-align: center;">
                  <div [ngStyle]="{fontSize: '20px', fontWeight: 'bold', color: headline.color || '#262626'}">
                    {{ headline.value }}
                  </div>
                  <div style="font-size: 11px; color: #8c8c8c;">
                    {{ headline.label }}
                  </div>
                </div>
              }
            </div>
          </div>
        }
        <!-- View link -->
        <div style="margin-top: 12px; text-align: right;">
          <span style="color: #1890ff; font-size: 13px;">
            View Dashboard <i nz-icon nzType="arrow-right"></i>
          </span>
        </div>
      </nz-card>
    </div>
  }
</div>

<!-- Empty state if no dashboards are accessible -->
@if (dashboardCards.length === 0) {
  <div style="text-align: center; padding: 64px 0;">
    <i nz-icon nzType="lock" style="font-size: 48px; color: #bfbfbf;"></i>
    <p style="margin-top: 16px; color: #8c8c8c;">
      No dashboards available. Contact your administrator for access.
    </p>
  </div>
}
